<template>
  <form>
    <h2>
      <span class="text-success">{{this.response_msg}}</span>
    </h2>
    <div v-for="(error, index) in this.response_error" :key="index">
      <span class="text-danger">{{error.message}}</span>
    </div>
    <md-card>
      <form>
        <md-card-header data-background-color="blue">
          <h4 class="title">Sign up</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="emailadress" type="email" name="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Password</label>
                <md-input v-model="password" type="password" name="password"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Repeat Password</label>
                <md-input v-model="repeat_password" type="password" name="repeatPassword"></md-input>
              </md-field>
            </div>
             <div class="md-layout-item md-small-size-100 md-size-50">
<a href="https://swarm.video/terms_and_conditions.html"><strong>Terms and conditions</strong> </a>
             </div>

            <div class="md-layout-item md-size-100 text-right">

              <md-button type="button" v-on:click="signUp()" class="md-raised md-success">Register and confirm terms and conditions</md-button>
            </div>
          </div>
        </md-card-content>
      </form>
    </md-card>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import { API } from "../../services/";

export default {
  name: "register-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      disabled: null,
      emailadress: null,
      password: null,
      repeat_password: null,
      response_msg: "",
      response_error: ""
    };
  },
  methods: {
    signUp() {
      API.doSignUp(this.emailadress, this.password, this.repeat_password).then(
        response => {
          if (response.data.success) {
            this.response_error = "";
            this.response_msg = response.data.message;
            setTimeout(this.$router.push("login"), 2500);
          } else {
            this.response_error = response.data.error.message;
          }
        }
      );
    }
  }
};
</script>
<style></style>
